/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NatRegistration } from '../models/NatRegistration';
import type { NatRegistrationCreateAdmin } from '../models/NatRegistrationCreateAdmin';
import type { NatRegistrationUpdate } from '../models/NatRegistrationUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NatRegistrationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List
     * @param schacc
     * @param subnet
     * @param limit
     * @param offset
     * @param uuid
     * @param outsideReg
     * @param authorization
     * @returns NatRegistration Successful Response
     * @throws ApiError
     */
    public listNatRegistrationsGet(
        schacc?: string,
        subnet?: string,
        limit: number = 50,
        offset?: number,
        uuid?: string,
        outsideReg?: string,
        authorization?: string,
    ): CancelablePromise<Array<NatRegistration>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/nat-registrations/',
            headers: {
                'authorization': authorization,
            },
            query: {
                'schacc': schacc,
                'subnet': subnet,
                'limit': limit,
                'offset': offset,
                'uuid': uuid,
                'outside_reg': outsideReg,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create
     * @param requestBody
     * @param authorization
     * @returns NatRegistration Successful Response
     * @throws ApiError
     */
    public createNatRegistrationsPost(
        requestBody: NatRegistrationCreateAdmin,
        authorization?: string,
    ): CancelablePromise<NatRegistration> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/nat-registrations/',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get
     * @param uuid
     * @param authorization
     * @returns NatRegistration Successful Response
     * @throws ApiError
     */
    public getNatRegistrationsUuidGet(
        uuid: string,
        authorization?: string,
    ): CancelablePromise<NatRegistration> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/nat-registrations/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update
     * @param uuid
     * @param requestBody
     * @param authorization
     * @returns NatRegistration Successful Response
     * @throws ApiError
     */
    public updateNatRegistrationsUuidPut(
        uuid: string,
        requestBody: NatRegistrationUpdate,
        authorization?: string,
    ): CancelablePromise<NatRegistration> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/nat-registrations/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete
     * @param uuid
     * @param authorization
     * @returns void
     * @throws ApiError
     */
    public deleteNatRegistrationsUuidDelete(
        uuid: string,
        authorization?: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/nat-registrations/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
